import styled from 'styled-components';

export const RewardAddEditContainerStyled = styled.div`
  .loading_show {
    width: 100%;
    height: calc(100vh - 245px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn_create {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .w120 {
      width: 120px;
    }
  }
  .body_table {
    margin-top: 20px;
    .body_status {
      display: flex;
      justify-content: center;
      .round {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        flex-shrink: 0;
      }
    }
  }
`;
